import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { blue, green, grey, orange, purple, red } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

const badgeTokens = [
  { propertyPath: 'default.background', tokenName: '--data-informative-neutral-low-contrast' },
  { propertyPath: 'default.fill', tokenName: '--semantic-data-informative-neutral' },
  { propertyPath: 'default.text', tokenName: '--data-informative-neutral-high-contrast' },
  { propertyPath: 'error.background', tokenName: '--data-informative-negative-low-contrast' },
  { propertyPath: 'error.fill', tokenName: '--semantic-data-informative-negative' },
  { propertyPath: 'error.text', tokenName: '--data-informative-negative-high-contrast' },
  { propertyPath: 'info.background', tokenName: '--data-informative-informative-low-contrast' },
  { propertyPath: 'info.fill', tokenName: '--semantic-data-informative-informative' },
  { propertyPath: 'info.text', tokenName: '--data-informative-informative-high-contrast' },
  { propertyPath: 'new.background', tokenName: '--data-informative-new-low-contrast' },
  { propertyPath: 'new.fill', tokenName: '--data-informative-new' },
  { propertyPath: 'new.text', tokenName: '--data-informative-new-high-contrast' },
  { propertyPath: 'success.background', tokenName: '--data-informative-positive-low-contrast' },
  { propertyPath: 'success.fill', tokenName: '--semantic-data-informative-positive' },
  { propertyPath: 'success.text', tokenName: '--data-informative-positive-high-contrast' },
  { propertyPath: 'warning.background', tokenName: '--data-informative-intermediate-low-contrast' },
  { propertyPath: 'warning.fill', tokenName: '--semantic-data-informative-intermediate' },
  { propertyPath: 'warning.text', tokenName: '--data-informative-intermediate-high-contrast' },
] satisfies Token[];

export const badgeTokenMetadata: PaletteTokenMetadata = {
  componentName: 'badge',
  tokens: badgeTokens,
};

export const badge = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['badge'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(badgeTokens, tokens, xcorTokens);
  }

  return mode === 'light'
    ? {
        default: { background: grey[150], fill: grey[400], text: grey[700] },
        error: { background: red[100], fill: red[600], text: red[700] },
        info: { background: blue[100], fill: blue[500], text: blue[700] },
        new: { background: purple[100], fill: purple[500], text: purple[700] },
        success: { background: green[100], fill: green[500], text: green[700] },
        warning: { background: orange[100], fill: orange[400], text: orange[700] },
      }
    : {
        default: { background: grey[800], fill: grey[400], text: grey[150] },
        error: { background: red[800], fill: red[500], text: red[100] },
        info: { background: blue[800], fill: blue[400], text: blue[100] },
        new: { background: purple[800], fill: purple[400], text: purple[100] },
        success: { background: green[800], fill: green[400], text: green[100] },
        warning: { background: orange[800], fill: orange[400], text: orange[100] },
      };
};
